import React, { useContext, useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import axiosClient from "../Utils/axiosClient";
import UnauthorizePage from "./UnauthorizePage";
import ForbiddenPage from "./ForbiddenPage";
import DatagridContext from "../Context/datagridContext";
import Datagrid from "../Components/Datagrid";
import ToastContext from "../Context/toastContext";
import toolbar from "../Config/toolbarConfig";
import editSettings from "../Config/editSettingsConfig";
import { useTranslation } from "react-i18next";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";

const CreditPage = () => {
  const [creditSetting, setCreditSetting] = useState(null);
  const [status, setStatus] = useState(null);
  const [from, setFrom] = useState("");
  const [url, setUrl] = useState("");

  const { t } = useTranslation();
  const { showToast } = useContext(ToastContext);
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useTitle(`${t("Credit Settings")} | Netileti`);

  //for the credit settings data
  const getData = async () => {
    setUrl(`${baseUrl}/creditsettings`);
    setFrom("CreditSettings");
  };

  //For the latest credit amount
  const fetchData = async () => {
    try {
      const response = await axiosClient.get(
        `${baseUrl}/creditsettings/GetLatest`
      );
      if (response.status === 200) {
        setStatus(null);
        const data = await response.data;
        if (data) setCreditSetting(data);
        else setCreditSetting([]);
      } else {
        setStatus(response.status);
        showToast(
          `${t("Error")}: ${response.statusText}`,
          "Http status :",
          response.status
        );
      }
    } catch (error) {
      setStatus(error.response?.status || 500);
      showToast(
        `${t("Failed to fetch data. Please try again.")}`,
        `${t("Error")}`
      );
    }
  };

  useEffect(() => {
    fetchData();
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const types = [
    { text: t("Whatsapp_Kredisi"), value: 0 },
    { text: t("Sms_Kredisi"), value: 1 },
    { text: t("Diğer"), value: 2 },
  ];
  const typeParams = {
    params: {
      fields: { text: "text", value: "value" },
      sortOrder: "none",
    },
  };

  const columns = [
    {
      field: "id",
      headerText: "id",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "type",
      headerText: t("Type"),
      allowEditing: true,
      editType: "dropdownedit",
      edit: typeParams,
      template: (props) => {
        console.log("types[props.type].text");
        return types[props.type].text || t("Unknown");
      },
      filterTemplate: () => (
        <ComboBoxComponent
          dataSource={types}
          fields={{ text: "text", value: "text" }}
          change={(e) => {
            const selectedValue = e.value;
            const gridElement = document.getElementById("adaptivebrowser");
            if (gridElement) {
              const grid = gridElement.ej2_instances[0];

              if (grid) {
                if (selectedValue) {
                  grid.filterByColumn("type", "equal", selectedValue);
                } else {
                  grid.removeFilteredColsByField("type");
                }
              }
            }
          }}
        />
      ),
    },
    {
      field: "description",
      headerText: t("Description"),
      allowEditing: true,
      validationRules: { maxLength: 50 },
    },
    {
      field: "amount",
      headerText: t("Amount"),
      allowEditing: true,
      validationRules: { required: true, number: true },
    },
    {
      field: "beginDate",
      headerText: t("Begin Date"),
      allowEditing: true,
      editType: "datepickeredit",
      format: { type: "date", format: "dd/MM/yyyy" },
      edit: {
        params: {
          format: "yyyy-MM-dd",
        },
      },
      type: "date",
    },
  ];

  if (!creditSetting) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center" }}
    >
      {/* <div className="credit-settings"> */}
      {/* <div className="settings-header">
          <h2 style={{ fontWeight: "350" }}>{t("Credit Settings")}</h2>
        </div> */}
      {/* <div className="credit-settings-content">
          <div className="e-card e-card-horizontal">
            <div className="e-card-stacked">
              <div className="e-card-header">
                <div className="e-card-header-caption">
                  <div className="e-card-header-title">
                    {creditSetting.type}
                  </div>
                </div>
              </div>
              <div className="e-card-content">
                {creditSetting.beginDate} - {t("Now")},{" "}
                <ChipListComponent cssClass="e-primary">
                  {creditSetting.amount} {t("credit(s)")}
                </ChipListComponent>{" "}
              </div>
            </div>
          </div>
        </div> */}
      {/* <div className="credit-settings-content"> */}
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            editSettings,
            toolbar: toolbar("CRUD"),
            url,
            from,
            setStatus,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
    // </div>
    // </div>
  );
};

export default CreditPage;
